export const CRITERIA_TYPES = {
	DATE: { name: "DATE", icon: "faCalendar" },
	// DATETIME: { name: "DATETIME", icon: "faCalendar" },
	// BOOLEAN: { name: "BOOLEAN", icon: "faCalendar" },
	TEXT: { name: "TEXT", icon: "faAlignLeft" },
	LIST: { name: "LIST", icon: "faList" },
	// TREE: { name: "TREE", icon: "faList" },
	DECIMAL: { name: "DECIMAL", icon: "faHashtag" },
	INTEGER: { name: "INTEGER", icon: "faEuroSign" },
	// NUMBER: { name: "NUMBER", icon: "faEuroSign" },
};
export const SECTION = {
	SECTION: "SECTION",
	SUBSECTION: "SUBSECTION",
};
